import { IoMdCube } from "react-icons/io";
import { HiUsers } from "react-icons/hi2";
import { IoCheckmarkDoneCircle } from "react-icons/io5";
import { RiTaskFill } from "react-icons/ri";

export const dataCards = [
  {
    statsData: [
      {
        label: "Total",
        value: 44,
        colorClass: "text-bl",
      },
      {
        label: "En cours",
        value: 16,
        bordure: "border-l-2  border-gray",
        colorClass: "text-orange",
      },
      {
        label: "En pause",
        value: 18,
        bordure: "border-l-2  border-gray",
        colorClass: "text-rg",
      },
      {
        label: "Terminés",
        value: 14,
        bordure: "border-l-2  border-gray",
        colorClass: "text-vr",
      },
    ],
    bgIcon: "bg-[#1abca4]/15",
    typeCard: "longue",
    cardData: {
      title: "Projets",
      icone: <IoMdCube className="text-3xl text-[#1abca4]" />,
    },
  },
  {
    statsData: [
      {
        label: "Total",
        value: 53,
        colorClass: "text-bl",
      },
      {
        label: "En cours",
        bordure: "border-l-2  border-gray",
        value: 22,
        colorClass: "text-orange",
      },
      {
        label: "En pause",
        value: 13,
        bordure: "border-l-2  border-gray",
        colorClass: "text-rg",
      },
      {
        bordure: "border-l-2  border-gray",
        label: "Terminées",
        value: 18,
        colorClass: "text-vr",
      },
    ],
    bgIcon: "bg-bl/15",
    typeCard: "longue",
    cardData: {
      title: "Tâches",
      icone: <RiTaskFill className="text-3xl text-bl" />,
    },
  },
  // Ajoutez d'autres cartes si nécessaire
];

export const cardsData = [
  {
    id: 4,
    typeCard: "courte",
    bgIcon: "bg-[#6a120466]/15",
    sousTitre: "Total Bakelistes ",
    icone: <HiUsers className="text-3xl text-[#6a120466]" />,
    total: "42",
  },
  {
    id: 2,
    typeCard: "courte",
    bgIcon: "bg-bl/15",
    sousTitre: "Bakelistes actifs",
    icone: <HiUsers className="text-3xl text-bl" />,
    total: "12",
  },
  {
    id: 3,
    typeCard: "courte",
    bgIcon: "bg-vr/15",
    sousTitre: "Backelistes Payés",
    icone: <HiUsers className="text-3xl text-vr" />,
    total: "25",
  },

  {
    id: 5,
    typeCard: "courte",
    bgIcon: "bg-[#d0280eef]/15",
    sousTitre: "Bakelistes Rétirés",
    icone: <HiUsers className="text-3xl text-[#d0280eef]" />,
    total: "13",
  },

  // livraisons
  {
    id: 6,
    typeCard: "courte",
    bgIcon: "bg-[#7d18caef]/15",
    sousTitre: "Total Livraisons",
    icone: <IoCheckmarkDoneCircle className="text-3xl text-[#7d18caef]" />,
    total: "11",
  },
  {
    id: 7,
    typeCard: "courte",
    bgIcon: "bg-orange/15",
    sousTitre: "Livraisons Validées",
    icone: <IoCheckmarkDoneCircle className="text-3xl text-orange" />,
    total: "14",
  },
  {
    id: 8,
    typeCard: "courte",
    bgIcon: "bg-[#243fdb]/15",
    sousTitre: "Livraisons Réjétées",
    icone: <IoCheckmarkDoneCircle className="text-3xl text-[#243fdb]" />,
    total: "14",
  },
  {
    id: 8,
    typeCard: "courte",
    bgIcon: "bg-[#243fdb]/15",
    sousTitre: "Livraisons Réjétées",
    icone: <IoCheckmarkDoneCircle className="text-3xl text-[#243fdb]" />,
    total: "14",
  },
 
];

export const stats = [
  {
    title: "Nombre de projets",
    value: 12,
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="text-orange" width="50" height="50" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m9.5 14.5l-6-2.5V4l6-2.5zm-6.885-1.244A1 1 0 0 1 2 12.333V3.667a1 1 0 0 1 .615-.923L8.923.115A1.5 1.5 0 0 1 11 1.5V2h1.25c.966 0 1.75.783 1.75 1.75v8.5A1.75 1.75 0 0 1 12.25 14H11v.5a1.5 1.5 0 0 1-2.077 1.385zM11 12.5h1.25a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25H11z" clip-rule="evenodd" /></svg>,
    color: "text-blue-500",
  },
  {
    title: "Nombre de tâches",
    value: 45,
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="text-green-500" width="50" height="50" viewBox="0 0 512 512"><path fill="currentColor" d="M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72l-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69l72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96m432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16m0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16m0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16" /></svg>,
    color: "text-green-500",
  },
  {
    title: "Nombre de livrables",
    value: 8,
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="text-orange-500" width="50" height="50" viewBox="0 0 32 32"><path fill="currentColor" d="m29.482 8.624l-10-5.5a1 1 0 0 0-.964 0l-10 5.5a1 1 0 0 0 0 1.752L18 15.591V26.31l-3.036-1.67L14 26.391l4.518 2.485a1 1 0 0 0 .964 0l10-5.5A1 1 0 0 0 30 22.5v-13a1 1 0 0 0-.518-.876M19 5.142L26.925 9.5L19 13.858L11.075 9.5Zm9 16.767l-8 4.4V15.59l8-4.4Z" /><path fill="currentColor" d="M10 16H2v-2h8zm2 8H4v-2h8zm2-4H6v-2h8z" /></svg>,
    color: "text-orange-500",
  },
  {
    title: "Nombre de Bakelistes",
    value: 5,
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="text-blue-500" width="50" height="50" viewBox="0 0 24 24"><path fill="currentColor" d="M24 14.6c0 .6-1.2 1-2.6 1.2c-.9-1.7-2.7-3-4.8-3.9c.2-.3.4-.5.6-.8h.8c3.1-.1 6 1.8 6 3.5M6.8 11H6c-3.1 0-6 1.9-6 3.6c0 .6 1.2 1 2.6 1.2c.9-1.7 2.7-3 4.8-3.9zm5.2 1c2.2 0 4-1.8 4-4s-1.8-4-4-4s-4 1.8-4 4s1.8 4 4 4m0 1c-4.1 0-8 2.6-8 5c0 2 8 2 8 2s8 0 8-2c0-2.4-3.9-5-8-5m5.7-3h.3c1.7 0 3-1.3 3-3s-1.3-3-3-3c-.5 0-.9.1-1.3.3c.8 1 1.3 2.3 1.3 3.7c0 .7-.1 1.4-.3 2M6 10h.3C6.1 9.4 6 8.7 6 8c0-1.4.5-2.7 1.3-3.7C6.9 4.1 6.5 4 6 4C4.3 4 3 5.3 3 7s1.3 3 3 3" /></svg>,
    color: "text-purple-500",
  },
];

export const taskData = [
  { date: "2025-02-01", state: "À faire" },
  { date: "2025-02-01", state: "En cours" },
  { date: "2025-02-01", state: "En cours" },
  { date: "2025-02-01", state: "En cours" },
  { date: "2025-02-03", state: "En cours" },
  { date: "2025-02-07", state: "Terminée" },
  { date: "2025-02-10", state: "En revue" },
  { date: "2025-02-15", state: "Acceptée" },
  { date: "2025-02-18", state: "À faire" },
  { date: "2025-02-20", state: "En cours" },
  { date: "2025-02-22", state: "Terminée" },
  { date: "2025-02-25", state: "En revue" },
  { date: "2025-02-28", state: "Acceptée" },
];